import $ from "jquery"
import messageResource from "../messageResource"
import {LeaveTypeColumnConfig, LeaveTypeBalanceQualifier} from "../reports/leavesReport/LeaveReportConfig"
import ListSelector from "./ListSelector";

function LeaveReportColumnsFormatSelector(){}

LeaveReportColumnsFormatSelector.prototype.init = function(id, initValue, onChangeCallback, enabledPTO, enabledSick){
    this.containerId = id;
    this.containerEl = $("#" + id);
    this.containerEl.addClass("i");
    
    var columnsConfig = initValue.columnsConfig;

    if (enabledSick && !enabledPTO)
        initValue.balanceQualifier = LeaveTypeBalanceQualifier.SICK_DAYS_ONLY;
                           
    if (!enabledSick && enabledPTO)
        initValue.balanceQualifier = LeaveTypeBalanceQualifier.PTO_ONLY;
    
    var balanceQualifier = initValue.balanceQualifier;
    
    var needPTOOption = enabledPTO || (balanceQualifier != LeaveTypeBalanceQualifier.SICK_DAYS_ONLY && columnsConfig != LeaveTypeColumnConfig.LEAVE_TIME_ONLY);
    var needSDBOption = enabledSick || (balanceQualifier != LeaveTypeBalanceQualifier.PTO_ONLY && columnsConfig != LeaveTypeColumnConfig.LEAVE_TIME_ONLY);

    this.columnsConfigSelector = this._createColumnsConfigSelector(this.containerEl, needPTOOption, needSDBOption, onChangeCallback);

    this.initBalanceQualifier = initValue.balanceQualifier;

    this.balanceTypeSelectorEnabled = needPTOOption && needSDBOption;

    if (this.balanceTypeSelectorEnabled) {
        this.balanceTypeSelectorEl = this._createBalanceTypeSelector(this.containerEl, onChangeCallback);
        this._selectBalanceTypeSelectorValue(initValue.balanceQualifier);
    } else {
        this.containerEl.addClass("withoutBalances");
    }

    this._setColumnsConfigSelectorValue(initValue.columnsConfig, true);

    return this;
};

LeaveReportColumnsFormatSelector.prototype.getValue = function(){
    var columnsConfig = this._getColumnsConfigSelectorValue();
    var balanceTypeValue;
    if(this.balanceTypeSelectorEnabled){
        balanceTypeValue = this._getBalanceTypeSelectorValue();
    } else {
        balanceTypeValue = this.initBalanceQualifier;
    }
    return {
        columnsConfig : columnsConfig,
        balanceQualifier  : balanceTypeValue
    };
};

LeaveReportColumnsFormatSelector.prototype.setActiveItemByValue = function( value , suppressChangeEvent) {
   this._setColumnsConfigSelectorValue(value.columnsConfig, suppressChangeEvent);
   if(this.balanceTypeSelectorEnabled){ this._selectBalanceTypeSelectorValue(value.balanceQualifier)}
};

LeaveReportColumnsFormatSelector.prototype._createBalanceTypeSelector = function(containerEl, onChangeCallback){

    var balanceTypeSelectorEl = $(document.createElement("div"));
    var options = [];

    options.push({
        value: LeaveTypeBalanceQualifier.PTO_AND_SICK_DAYS,
        label: messageResource.getMessage("report.leaves.configure_columns.balance_type_label.pto_and_sick_days")
    });
    options.push({
        value: LeaveTypeBalanceQualifier.PTO_ONLY,
        label: messageResource.getMessage("report.leaves.configure_columns.balance_type_label.pto")
    });
    options.push({
        value: LeaveTypeBalanceQualifier.SICK_DAYS_ONLY,
        label: messageResource.getMessage("report.leaves.configure_columns.balance_type_label.sick_days")
    });

    $.each(
        options,
        function(id, option){
            var optionDiv = $("<div></div>");
            optionDiv.addClass("option");
            var input = $("<input type='radio' name='balanceType'/>");
            input.attr("id", id);
            input.attr("value", option.value);
            input.on("change", function(event){
                onChangeCallback();
            });

            optionDiv.append(input);
            var label = $("<label></label>");
            label.text(option.label);
            label.attr("for", id);
            optionDiv.append(label);
            balanceTypeSelectorEl.append(optionDiv);
        }
    );

    balanceTypeSelectorEl.attr("id", "balanceTypeSelector");
    balanceTypeSelectorEl.addClass("balanceTypeSelector");
    containerEl.append(balanceTypeSelectorEl);

    return balanceTypeSelectorEl;
};

LeaveReportColumnsFormatSelector.prototype._selectBalanceTypeSelectorValue = function(value) {
    this.balanceTypeSelectorEl.find("input[value=" + value + "]").prop("checked", true);
};
LeaveReportColumnsFormatSelector.prototype._getBalanceTypeSelectorValue = function(){
    return this.balanceTypeSelectorEl.find("input:checked").attr("value");
};

LeaveReportColumnsFormatSelector.prototype._disableBalanceTypeSelector = function(isDisable) {
    this.balanceTypeSelectorEl.toggleClass("disable", isDisable);
    this.balanceTypeSelectorEl.find("input").prop("disabled", isDisable);
};

LeaveReportColumnsFormatSelector.prototype._createColumnsConfigSelector = function(containerEl, needPTOOption, needSDBOption, onChangeCallback) {
    var columnsTypeSelectorContainerEl = $(document.createElement("div"));
    columnsTypeSelectorContainerEl.attr("id", "columnsTypeSelector");
    columnsTypeSelectorContainerEl.addClass("columnsTypeSelector");
    containerEl.append(columnsTypeSelectorContainerEl);

    columnsTypeSelectorContainerEl.append("<div class='title'>" + messageResource.getMessage("report.leaves.configure_columns.show") + "</div>");

    var columnsConfigSelector = new ListSelector({
        renderTo: "columnsTypeSelector",
        menuCls: "columnsFormatMenu"
    });

    var balancesTextKey;
    if (needPTOOption && needSDBOption) {
        balancesTextKey = "report.leaves.configure_columns.both_balances";
    } else if (needPTOOption) {
        balancesTextKey = "report.leaves.configure_columns.pto_balance";
    } else {
        balancesTextKey = "report.leaves.configure_columns.sick_days_balance";
    }

    var balancesText = messageResource.getMessage(balancesTextKey);

    columnsConfigSelector.addItems([
        {
            text:  messageResource.getEscapedMessage("report.leaves.configure_columns.leave_time_and", [balancesText]),
            value: LeaveTypeColumnConfig.LEAVE_TIME_AND_BALANCES
        },
        {
            text: messageResource.getEscapedMessage("report.leaves.configure_columns.leave_time_only"),
            value: LeaveTypeColumnConfig.LEAVE_TIME_ONLY
        },
        {
            text: messageResource.getEscapedMessage("report.leaves.configure_columns.balances_only", [balancesText]),
            value: LeaveTypeColumnConfig.BALANCES_ONLY
        }
    ]);


    var self = this;
    columnsConfigSelector.on("change", function(){
            if(self.balanceTypeSelectorEnabled) {
                self._disableBalanceTypeSelector(columnsConfigSelector.getSelectedItem().value == LeaveTypeColumnConfig.LEAVE_TIME_ONLY);
            }

            onChangeCallback();
        }
    );

    return columnsConfigSelector;
};

LeaveReportColumnsFormatSelector.prototype._setColumnsConfigSelectorValue = function(value , suppressChangeEvent){
    if(this.balanceTypeSelectorEnabled){
        this._disableBalanceTypeSelector(value == LeaveTypeColumnConfig.LEAVE_TIME_ONLY);
    }
    this.columnsConfigSelector.setActiveItemByValue(value, suppressChangeEvent);
};

LeaveReportColumnsFormatSelector.prototype._getColumnsConfigSelectorValue = function(){
    return this.columnsConfigSelector.getSelectedItem().value;
};

export default LeaveReportColumnsFormatSelector



// WEBPACK FOOTER //
// ./web/js/controls/LeaveReportColumnsFormatSelector.js